<template>
  <div
    class="image-container"
    @mouseenter="$emit('hover', index)"
    @mouseleave="$emit('leave')"
  >
    <img
      :src="image.src"
      :alt="image.text[fontType]"
      class="img-fluid image-element"
      loading="lazy"
    />
    <router-link
      :to="{ name: image.href }"
      class="image-text"
      style="text-align: start;"
    >
      <p class="our-school-title-name mb-2">
        {{ image.text[fontType] }}
      </p>
      <p class="our-school-age-text">
        {{ image.age[fontType] }}
      </p>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'ImageCard',

  props: {
    image: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true
    },
    fontType: {
      type: String,
      required: true
    },
  },

  emits: ['hover', 'leave']
}
</script>

<style lang="scss" scoped>
.image-container {
  width: 25%;
  position: relative;
  cursor: pointer;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  border-radius: 10px;
  margin: 0 10px;
}

.image-element {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
  filter: brightness(0.8) saturate(1.2);
}

.image-container:hover .image-element {
  filter: brightness(1) saturate(1.4);
  transform: scale(1.02);
}

.image-text {
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  color: white;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  padding: 25px;
  border-radius: 10px;
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    cursor: pointer;

    p {
      color: var(--cus-secondary) !important;
    }
  }
}

.image-container:hover .image-text {
  transform: translateY(0px);
}

.our-school-title-name {
  transition: color !important;
  text-transform: uppercase;
  color: white;
  font-family: Poppins;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.5px;
  vertical-align: middle;
}

.our-school-age-text {
  color: #ffffff;
  font-family: Poppins;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0px;
  color: white;
}

@media (max-width: 768px) {
  .image-container {
    flex: 1 25%;
    min-width: 75%;
  }
}
</style>
